import { render, staticRenderFns } from "./FirstFlgV2.vue?vue&type=template&id=f64fb4e2&"
import script from "./FirstFlgV2.vue?vue&type=script&lang=ts&"
export * from "./FirstFlgV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports